export enum ErrorCode {
	UNKNOWN_REASON = "UNKNOWN_REASON",

	// client codes
	NETWORK_ERROR = "NETWORK_ERROR",
	PAGE_NOT_FOUND = "PAGE_NOT_FOUND",
	ACCESS_CODE_ERROR = "ACCESS_CODE_ERROR",
	AUTHENTICATION_ERROR = "AUTHENTICATION_ERROR",
	UNAUTHORIZED = "UNAUTHORIZED",
	ILLEGAL_CONFIGURATIONS_STATE = "ILLEGAL_CONFIGURATIONS_STATE",
	SERVICE_NOT_FOUND = "SERVICE_NOT_FOUND",
	SERVICE_FAILED = "SERVICE_FAILED",
	SERVICE_PROGRESS_FAILED = "SERVICE_PROGRESS_FAILED",
	SERVICE_ABORT_FAILED = "SERVICE_ABORT_FAILED",

	// server codes
	SESSION_NOT_FOUND = "SESSION_NOT_FOUND",
	SESSION_INITIALIZATION_ERROR = "SESSION_INITIALIZATION_ERROR",
	EMPTY_ACCESS_CODE = "EMPTY_ACCESS_CODE",
	ACCESS_CODE_NOT_FOUND = "ACCESS_CODE_NOT_FOUND",
	ACCESS_CODE_INVALID = "ACCESS_CODE_INVALID",
	ACCESS_CODE_ALREADY_CONSUMED = "ACCESS_CODE_ALREADY_CONSUMED",
	ACCESS_CODE_EXPIRED = "ACCESS_CODE_EXPIRED",
	GENERIC_ERROR = "GENERIC_ERROR",
	INVALID_SESSION_ID = "INVALID_SESSION_ID"
}

export interface ServerEnvelope<T> {
	status: string;
	timestamp: string;
	data?: T;
	error?: {
		code: ErrorCode;
		details?: string;
		[k: string]: unknown;
	};
}

export class ApiError extends Error {
	status: number;
	code: ErrorCode;
	details?: string;
	response?: Response;
	body?: unknown;

	constructor(opts: {
		status: number;
		code: ErrorCode;
		details?: string;
		response?: Response;
		body?: unknown;
	}) {
		super("api error");
		this.name = 'ApiError';
		this.code = opts.code;
		this.status = opts.status;
		this.details = opts.details;
		this.response = opts.response;
		this.body = opts.body;
	}
}

export class FormDataAbortedError extends Error {
	constructor() {
		super("Operation aborted");
		this.name = "FormDataAbortedError";
	}
}